import { DepartmentApi, IBranch } from 'api'
import { useBranchUsersList } from 'modules/auth/ActiveDirectoryPageContent/hooks'
import { useAuth } from 'modules/auth/hooks'
import queries from 'modules/common/queries'
import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

export function useUsersBranchById(branchId?: IBranch['id']): IBranch | undefined {
	const { user } = useAuth()
	return user?.branches.find(branch => branch.id === branchId)
}

export function useWhitelabelSettings(enabled = true) {
	return useQuery({
		queryKey: [queries.whitelabel],
		queryFn: DepartmentApi.getWhitelabelSettings,
		enabled,
	})
}

export function useUserBranches(enabled = true) {
	return useQuery({
		queryKey: [queries.branches],
		queryFn: DepartmentApi.getUserBranches,
		enabled,
	})
}

export function useDepartmentMembers(branchId?: IBranch['id']) {
	const { user } = useAuth()
	const { data: departmentMembers = [], isLoading: areDepartmentMembersLoading, isError: isGettingMembersError, refetch: refetchDepartments } = useBranchUsersList(branchId)

	const departmentOptions = useMemo(
		() =>
			(user?.branches || []).map(userDepartment => ({
				value: userDepartment.id,
				label: userDepartment.name,
			})),
		[user]
	)

	const departmentMemberOptions = useMemo(
		() =>
			departmentMembers.map(({ id, fullName }) => ({
				value: id,
				label: fullName,
			})),
		[departmentMembers]
	)

	return {
		departmentMembers,
		departmentOptions,
		departmentMemberOptions,
		areDepartmentMembersLoading,
    isGettingMembersError,
    refetchDepartments
	}
}
